import { useEffect, useState } from 'react'
import IncomeOverview from '../components/IncomeOverview'

function Main() {
  const [incomeOverviewOpen, setIncomeOverviewOpen] = useState(false)

  useEffect(() => {
    setIncomeOverviewOpen(
      window.localStorage.getItem('income-overview-open') === 'true'
    )
  }, [])

  return (
    <div>
      {incomeOverviewOpen && <IncomeOverview open={incomeOverviewOpen} />}
    </div>
  )
}

export default Main
